/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./download-resource-button.vue?vue&type=template&id=daa2f0be&scoped=true&"
import script from "./download-resource-button.vue?vue&type=script&lang=js&"
export * from "./download-resource-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa2f0be",
  null
  
)

export default component.exports